// @flow
import * as React from 'react';
import './style.scss';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import {
    isMobile
} from "react-device-detect";
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    header: {
        height: "55px",
        backgroundColor: "#fff",
        zIndex: 999,
        opacity: 0.9
    },
    toolbar: {
        height: "55px",
        minHeight: "55px"
    },
    title: {
        justifyContent: "center",
        alignItems: "center",
        color: "#000"
    },
    menuBtnsContainer: {
        marginLeft: "70px"
    },
    menuBtn: {
        height: "55px",
        marginLeft: "16px",
        justifyContent: "center",
        alignItems: "center",
        color: "#000",
        fontSize: "16px",
        textTransform: "inherit"
    },
    mobileMenuBtn: {
        position: "fixed",
        right: "10px"
    },
    list: {
        width: "100%",
    },
    fullList: {
        width: 'auto',
    },
    mobileMenuList: {
        width: "100%"
    }
}));


function Header(props) {
    const classes = useStyles();
    const [state, setState] = React.useState(false);
    const { isDataMenuOpen, setDataMenuStatus } = props;

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState(open);
    };

    const list = (anchor) => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === 'bottom',
            })}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            <List>
                <ListItem onClick={() => window.open("https://mavivatan.net/mavi-vatan")} button >
                    <ListItemText>Mavi Vatan</ListItemText>
                </ListItem>
                <ListItem onClick={() => window.open("https://mavivatan.net/hakkimizda")} button >
                    <ListItemText>Hakkımızda</ListItemText>
                </ListItem>
                <ListItem onClick={() => setDataMenuStatus(!isDataMenuOpen)} button >
                    <ListItemText>Veri Setleri</ListItemText>
                </ListItem>
                <ListItem onClick={() => window.open("https://mavivatan.net/iletisim")} button >
                    <ListItemText>İletişim</ListItemText>
                </ListItem>
            </List>
        </div>
    );

    return (
        <AppBar className={classes.header} position="fixed">
            <Toolbar className={classes.toolbar}>
                <Typography onClick={() => window.location.href = 'https://mavivatan.net'} variant="h6" className={classes.title}>
                    mavivatan.net
                </Typography>
                {
                    isMobile ? <div className={classes.mobileMenuBtn}>
                        <IconButton edge="start" onClick={toggleDrawer(true)} aria-label="menu">
                            <MenuIcon />
                        </IconButton>
                        <Drawer anchor="bottom" open={state} onClose={toggleDrawer(false)}>
                            {list()}
                        </Drawer>
                    </div>
                        :
                        <div className={classes.menuBtnsContainer}>
                            <Button href="https://mavivatan.net/mavi-vatan" className={classes.menuBtn} >Mavi Vatan</Button>
                            <Button href="https://mavivatan.net/hakkimizda" className={classes.menuBtn} >Hakkımızda</Button>
                            <Button className={classes.menuBtn} onClick={() => setDataMenuStatus(!isDataMenuOpen)}>Veri Setleri</Button>
                            <Button href="https://mavivatan.net/iletisim" className={classes.menuBtn} >İletişim</Button>
                        </div>
                }
            </Toolbar>
        </AppBar>
    );
}


export default Header;